import { useState, useEffect } from 'react';

// A custom hook that handles debouncing
const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    },
        [value, delay]);

    return debouncedValue;
}

export default useDebounce;